<template>
  <AppHeader />
  <Suspense>
    <template #default>
  <HomePage />
    </template>
    <template #fallback>
      <AppLoading />
    </template>
  </Suspense>
</template>

<script>
// @ is an alias to /src
import { defineAsyncComponent, Suspense } from "vue";
import AppLoading from "@/components/Include/AppLoading.vue";
import AppHeader from "@/components/Include/AppHeader.vue";
const HomePage = defineAsyncComponent(() =>
  import('@/components/Pages/HomePage.vue')
)
export default {
  name: "HomeView",
  components: {
    Suspense,
    AppLoading,
    AppHeader,
    HomePage,
    
  },
};
</script>
